export const WebRoutes = {
    SIGN_IN: "/sign-in",
    SIGN_UP: "/sign-up",
    DASHBOARD: "/dashboard",
    PLANS: "/phonelines",
    RECHARGE: "/recharge",
    USERS: "/users",
    CONVERSATIONS: "/conversations",
    CONVERSATION_HISTORY: "/conversations/:id",
    SCHEDULED_MESSAGES: "/scheduled-messages",
    CONTACTS: "/contacts",
    IMPORT_CONTACTS: "/contacts/import-contacts",
    CUSTOM_ATTRIBUTES: "/contacts/custom-attributes",
    IMPORT_CONTACTS_EXCEL: "/contacts/import-contacts/excel",
    IMPORT_CONTACTS_OUTLOOK: "/contacts/import-contacts/outlook",
    GROUPS: "/groups",
    PROFILE: "/profile",
    SETTINGS: "/settings",
    GENERAL: "/settings/general",
    BLOCKED: "/settings/blocked",
    UNSUBSCRIBE: "/settings/unsubscribe",
    SIGNATURE: "/settings/signature",
    LOW_CREDIT_NOTIFICATION: "/settings/low-credit-notification",
    TIMEZONE: "/settings/timezone",
    SCHEDULED_REPORT: "/settings/scheduledreport",
    NOTIFICATION_SETTINGS: "/settings/notification",
    CHANGE_PASSWORD: "/change-password",
    ADD_PHONE_NUMBER: "/add-number",
    PAYMENT_STATUS: "/payment-status",
    REHOST: "/rehost",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD_NEW: "/reset-password",
    TWO_FACTOR_AUTHENTICATION: "/2fa",
    ORGANIZATIONS: "/organizations",
    PHONE_NUMBERS: "/phone-numbers",
    TIERS: "/sysadmin-plans",
    ADD_PLAN: "/sysadmin-plans/:PlanID",
    FEATURES: "/features",
    RESET_PASSWORD_OLD: "/ResetPassword",
    HOME_PATH: "/",
    TRANSFERS: "/transfers",
    AUTOMATE_TRANSFER: "/transfers/automate-transfer",
    TRANSFER_LOGS: "/transfers/logs",
    ALERTS: "/alerts",
    TEMPLATES: "/templates",
    TEMPLATES_PUBLIC: "/templates/public",
    TEMPLATES_PHONE_NUMBER: "/templates/phone-number",
    AUTOMATION_RULES: "/automation",
    AUTOMATION_KEYWORD: "/automation/keyword",
    AUTOMATION_LOGS: "/automation/logs",
    AUTOMATION_RULES_GLOBAL: "/automation/rules/global-rules",
    FALKON_DOCS: "/falkon-docs",
    FALKON_DOCS_UPLOADS: "/falkon-docs/uploads",
    FALKON_DOCS_UPDATE: "/falkon-docs/update",
    FALKON_DOCS_SUCCESS: "/falkon-docs/success",
    FALKON_DOCS_OTP: "/falkon-docs/otp",
    FALKON_DOCS_VERIFY_OTP: "/falkon-docs/verifyotp",
    FALKON_DOCS_END_USER_SIGN: "/falkon-docs/sign",
    FALKON_DOCS_END_USER_SIGN_SUCCESS: "/falkon-docs/sign/success",
    FALKON_DOCS_COMPLETED: "/falkon-docs/completedDoc",
    REPORTS: "/reports/schedule-broadcast-logs",
    REPORT_VIEW: "/reports/report-view",
    PLANS_PLAN_HISTORY: "/plans/:phoneID/plan-history",
    PHONE_NUMBERS_PLAN_HISTORY: "/phone-numbers/:phoneID/plan-history",
    SWITCH_PHONE_NUMBER: "/switch-number",
    KAFKA_CLUSTER: "/kafka-cluster",
    GROUPDELETIONINFO: "/groups/group-contacts-deletion-info",
    SSO_ERROR_PAGE: "/sso-error/:state",
    SECURE_FILE: "/secure-files",
    SECURE_FILE_FACE_AUTHENTICATION: "/secure-files/face-authentication",
    SECURE_FILE_REDIRECT: "/securedFile",
    CreditLog: "/reports/creditLog",
    ExportReport: "/reports/exportreport",
    SecureChat_ExportReport: "/reports/Securechat/exportreport",
    MESSAGE_LOGS: "/reports/message-logs",
    SECURE_CHAT_MESSAGE_LOGS: "/reports/securechat/message-logs",
    TEAMS_CHANNEL_SETUP: "/integrations/channel-setup",
    CLIO: "/integrations/clio",
    TEAMS_ACTIVITY_FEED: "/integrations/mst-activity-feed",
    SLACK: "/integrations/slack-setup",
    INTEGRATIIONS: "/integrations",
    CLIO_CALLBACK: "/integrations/clio",
    HUBSPOT: "/integrations/hubspot",
    HUBSPOT_CALLBACK: "/integrations/hubspot",
    AFTER_HOURS: "/settings/after-hours",
    FACE_REGISTRATION: "/face-registration",
    FACE_VERIFICATION: "/face-verification",
    COMPLIANCE_MESSAGE: "/settings/complianceMsg",
    OUTLOOK: "/integrations/outlook",
    OPTOUT_POLICY: "/reports/opt-out-policy",
    BLOCKED_CONTACTS_LIST: "/reports/blocked",
    SLACK_CALLBACK: "/integrations/slack-setup",
    FALKON_SECURE_CHAT: "/falkon/secure-chat",
    SECURE_CONVERSATIONS: "/secure-chat",
    FEATURE_FLAG: "/settings/feature-flag",
    FALKON_AI: "/falkon-ai",
    PHONENUMBER_GROUPS: "/phonelines/phonenumbergroups",
    PHONENUMBER_GROUPS_SYSADM: "/phonenumbergroups",
    NEW_PLANS: "/new-plans",
    ADD_NEW_PLAN: "/new-plans/:PlanID",
    NEW_ORGANIZATION: "/new-organization",
    NEW_PhONE_NUMBER: "/new-phone-number",
    NEW_USERS: "/new-users",
    NEW_RECHARGE: "/new-recharge",
    NEW_ADD_PHONE_NUMBER: "/new-add-phone-number",
    ORGANIZATION_PLAN_HISTORY: "/organization/:orgId/plan-history",
    NEW_PAYMENT_STATUS: "/new-payment-status",
    ACCOUNT_BILLING: "/account-billing",
    IMPORT_SCHEDULED_MESSAGES: "/scheduled-messages/import-schedules",
    AI_MONITERING: "/falkon-ai/analytics",
    WEB_FORMS: "/web-form",
    WEB_FORM_HISTORY: "/web-form/:formId/history",
    WEB_FORM_END_USER_VIEW: "/webform",
    WEBFORM: "/integrations/webform",
    API_ACCESS: "/settings/Api-access",
}

export const TeamsRoutes = {
    SIGN_IN: "/teams/sign-in",
    SIGN_UP: "/teams/sign-up",
    DASHBOARD: "/teams/dashboard",
    PLANS: "/teams/phonelines",
    RECHARGE: "/teams/recharge",
    USERS: "/teams/users",
    CONVERSATIONS: "/teams/conversations",
    CONVERSATION_HISTORY: "/teams/conversations/:id",
    SCHEDULED_MESSAGES: "/teams/scheduled-messages",
    CONTACTS: "/teams/contacts",
    IMPORT_CONTACTS: "/teams/contacts/import-contacts",
    CUSTOM_ATTRIBUTES: "/teams/contacts/custom-attributes",
    IMPORT_CONTACTS_EXCEL: "/teams/contacts/import-contacts/excel",
    IMPORT_CONTACTS_OUTLOOK: "/teams/contacts/import-contacts/outlook",
    GROUPS: "/teams/groups",
    PROFILE: "/teams/profile",
    SETTINGS: "/teams/settings",
    GENERAL: "/teams/settings/general",
    BLOCKED: "/teams/settings/blocked",
    UNSUBSCRIBE: "/teams/settings/unsubscribe",
    SIGNATURE: "/teams/settings/signature",
    LOW_CREDIT_NOTIFICATION: "/teams/settings/low-credit-notification",
    TIMEZONE: "/teams/settings/timezone",
    SCHEDULED_REPORT: "/teams/settings/scheduledreport",
    NOTIFICATION_SETTINGS: "/teams/settings/notification",
    CHANGE_PASSWORD: "/teams/change-password",
    ADD_PHONE_NUMBER: "/teams/add-number",
    PAYMENT_STATUS: "/teams/payment-status",
    REHOST: "/teams/rehost",
    FORGOT_PASSWORD: "/teams/forgot-password",
    RESET_PASSWORD_NEW: "/teams/reset-password",
    TWO_FACTOR_AUTHENTICATION: "/teams/2fa",
    ORGANIZATIONS: "/teams/organizations",
    PHONE_NUMBERS: "/teams/phone-numbers",
    TIERS: "/teams/sysadmin-phonelines",
    ADD_PLAN: "/teams/sysadmin-plans/:PlanID",
    FEATURES: "/teams/features",
    RESET_PASSWORD_OLD: "/teams/ResetPassword",
    ALERTS: "/teams/alerts",
    AUTOMATION_RULES: "/teams/automation",
    AUTOMATION_KEYWORD: "/teams/automation/keyword",
    AUTOMATION_LOGS: "/teams/automation/logs",
    FALKON_DOCS: "/teams/falkon-docs",
    FALKON_DOCS_UPLOADS: "/teams/falkon-docs/uploads",
    FALKON_DOCS_UPDATE: "/teams/falkon-docs/update",
    FALKON_DOCS_SUCCESS: "/teams/falkon-docs/success",
    FALKON_DOCS_OTP: "/teams/falkon-docs/otp",
    FALKON_DOCS_VERIFY_OTP: "/teams/falkon-docs/verifyotp",
    FALKON_DOCS_END_USER_SIGN: "/teams/falkon-docs/sign",
    FALKON_DOCS_END_USER_SIGN_SUCCESS: "/teams/falkon-docs/sign/success",
    FALKON_DOCS_COMPLETED: "/teams/falkon-docs/completedDoc",
    AUTOMATE_TRANSFER: "/teams/transfers/automate-transfer",
    HOME_PATH: "/teams",
    TRANSFERS: "/teams/transfers",
    TRANSFER_LOGS: "/teams/transfers/logs",
    TEMPLATES: "/teams/templates",
    TEMPLATES_PUBLIC: "/teams/templates/public",
    TEMPLATES_PHONE_NUMBER: "/teams/templates/phone-number",
    AUTOMATION_RULES_GLOBAL: "/teams/automation/rules/global-rules",
    REPORTS: "/teams/reports/schedule-broadcast-logs",
    REPORT_VIEW: "/teams/reports/report-view",
    PLANS_PLAN_HISTORY: "/teams/plans/:phoneID/plan-history",
    PHONE_NUMBERS_PLAN_HISTORY: "/teams/phone-numbers/:phoneID/plan-history",
    SWITCH_PHONE_NUMBER: "/teams/switch-number",
    KAFKA_CLUSTER: "/teams/kafka-cluster",
    GROUPDELETIONINFO: "/teams/groups/group-contacts-deletion-info",
    TEAMS_LOGIN_PAGE: "/teams/tab-auth/simple-start",
    TEAMS_LOGIN_PAGE_SSO: "/teams/sso-teams-start",
    TEAMS_CONCENTPOPUP_END_SSO: "/teams/sso-teams-end",
    SSO_ERROR_PAGE: "/teams/sso-error/:state",
    TEAMS_CONCENTPOPUP_END: "/teams/tab-auth/simple-end",
    SECURE_FILE: "/teams/secure-files",
    SECURE_FILE_FACE_AUTHENTICATION: "/teams/secure-files/face-authentication",
    SECURE_FILE_REDIRECT: "/teams/securedFile",
    CreditLog: "/teams/reports/creditLog",
    ExportReport: "/teams/reports/exportreport",
    SecureChat_ExportReport: "/teams/reports/Securechat/exportreport",
    MESSAGE_LOGS: "/teams/reports/message-logs",
    SECURE_CHAT_MESSAGE_LOGS: "/teams/reports/securechat/message-logs",
    TEAMS_CHANNEL_SETUP: "/teams/integrations/channel-setup",
    INTEGRATIIONS: "/teams/integrations",
    CLIO: "/teams/integrations/clio",
    TEAMS_ACTIVITY_FEED: "/teams/integrations/mst-activity-feed",
    SLACK: "/teams/integrations/slack-setup",
    CLIO_POPUP: "/teams/integrations/clio/clio-popup",
    CLIO_CALLBACK: "/teams/integrations/clio",
    HUBSPOT: "/teams/integrations/hubspot",
    HUBSPOT_CALLBACK: "/teams/integrations/hubspot",
    HUBSPOT_POPUP: "/teams/integrations/hubspot/hubspot-popup",
    AFTER_HOURS: "/teams/settings/after-hours",
    COMPLIANCE_MESSAGE: "/teams/settings/complianceMsg",
    FACE_REGISTRATION: "/teams/face-registration",
    FACE_VERIFICATION: "/teams/face-verification",
    SECURE_CONVERSATIONS: "/teams/secure-chat",
    OUTLOOK: "/teams/integrations/outlook",
    OUTLOOK_POPUP: "/teams/integrations/outlook/outlook-popup",
    OUTLOOK_CALLBACK: "/teams/integrations/outlook",
    OPTOUT_POLICY: "/teams/reports/opt-out-policy",
    BLOCKED_CONTACTS_LIST: "/teams/reports/blocked",
    SLACK_POPUP: "/teams/integrations/slack/slack-popup",
    SLACK_CALLBACK: "/teams/integrations/slack-setup",
    FEATURE_FLAG: "/teams/settings/feature-flag",
    FALKON_AI: "/teams/falkon-ai",
    PHONENUMBER_GROUPS: "/teams/phonelines/phonenumbergroups",
    PHONENUMBER_GROUPS_SYSADM: "/teams/phonenumbergroups",
    NEW_ORGANIZATION: "/teams/new-organization",
    NEW_PhONE_NUMBER: "/teams/new-phone-number",
    NEW_USERS: "/teams/new-users",
    NEW_RECHARGE: "/teams/new-recharge",
    NEW_ADD_PHONE_NUMBER: "/teams/new-add-phone-number",
    NEW_PLANS: "/teams/new-plans",
    ORGANIZATION_PLAN_HISTORY: "/teams/organization/:orgId/plan-history",
    NEW_PAYMENT_STATUS: "/teams/new-payment-status",
    ADD_NEW_PLAN: "/teams/new-plans/:PlanID",
    ACCOUNT_BILLING: "/teams/account-billing",
    IMPORT_SCHEDULED_MESSAGES: "/teams/scheduled-messages/import-schedules",
    AI_MONITERING: "/teams/falkon-ai/analytics",
    WEB_FORMS: "/teams/web-form",
    WEB_FORM_HISTORY: "/teams/web-form/:formId/history",
    WEB_FORM_END_USER_VIEW: "/teams/webform",
    WEBFORM: "/teams/integrations/webform",
    API_ACCESS: "/teams/settings/Api-access",
}

export const AppRoutes = window.location.pathname.includes('teams') ? TeamsRoutes : WebRoutes;